import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.rocketzUpsellDirectInstalled) {
  window.rocketzUpsellDirectInstalled = true;
  let pending = false;

  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest('[data-cart-upsell-action]');
    const card = button?.closest('[data-cart-upsell-card]');
    const upsell = button?.closest('cart-upsell-carousel');

    if (!button || !card || !upsell) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (pending || button.disabled) return;

    pending = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    let feedback = upsell.querySelector('[data-cart-upsell-feedback]');

    if (!feedback) {
      feedback = document.createElement('p');
      feedback.setAttribute('data-cart-upsell-feedback', '');
      feedback.setAttribute('role', 'status');
      feedback.setAttribute('aria-live', 'polite');
      upsell.append(feedback);
    }

    feedback.textContent = '';

    try {
      const variantId =
        card.querySelector('input[name="id"]')?.value ||
        button.dataset.variantId;

      const quantity = Number(
        card.querySelector('input[name="quantity"]')?.value ||
        button.dataset.quantity ||
        1
      );

      if (!variantId) {
        throw new Error(
          'Não foi possível identificar a variante do produto.'
        );
      }

      const root = window.Shopify?.routes?.root || '/';

      const sections = [...new Set(
        Array.from(document.querySelectorAll('cart-items-component'))
          .map((item) => item.dataset.sectionId)
          .filter(Boolean)
      )].slice(0, 5);

      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity }],
          sections,
          sections_url: window.location.pathname,
        }),
      });

      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(
          result.description ||
          result.message ||
          'Não foi possível adicionar o produto.'
        );
      }

      const promise = fetch(`${root}cart.js`, {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
      }).then(async (cartResponse) => {
        if (!cartResponse.ok) {
          throw new Error(
            'Produto adicionado. Recarregue a página para atualizar o carrinho.'
          );
        }

        const cart = await cartResponse.json();

        return {
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: {
            items: cart.items,
            sections: result.sections,
            source: 'cart-upsell',
            itemCount: quantity,
            didError: false,
          },
        };
      });

      document.dispatchEvent(new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: variantId, quantity }],
        promise,
      }));

      await promise;
    } catch (error) {
      feedback.textContent =
        error.message || 'Não foi possível adicionar. Tente novamente.';

      console.error('[cart-upsell]', error);
    } finally {
      pending = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }, true);
}